module.exports = __webpack_public_path__ + "img/user_icon.797d7c2c.svg";